(function () {
  const currentScript = document.currentScript;
  const scriptOrigin = currentScript ? new URL(currentScript.src).origin : window.location.origin;
  const apiBase = currentScript?.dataset.apiBase || window.CIEL_AGENT_API_BASE || scriptOrigin;
  const assetBase = currentScript?.dataset.assetBase || scriptOrigin;
  const smartlineSrc = currentScript?.dataset.smartlineSrc || `${assetBase}/smartline/agent.js`;
  const shop = currentScript?.dataset.shop || window.CIEL_AGENT_SHOP || '';

  if (window.__cielConciergeWidgetLoaded) return;
  window.__cielConciergeWidgetLoaded = true;
  window.SMARTLINE_API_BASE = apiBase;
  window.CIEL_AGENT_SHOP = shop;

  function injectCss() {
    const existing = document.querySelector('style[data-ciel-concierge-style]');
    if (existing) return;
    const style = document.createElement('style');
    style.dataset.cielConciergeStyle = 'true';
    style.textContent = `
      .ciel-concierge-launcher {
        position: fixed;
        right: max(22px, env(safe-area-inset-right));
        bottom: max(22px, env(safe-area-inset-bottom));
        z-index: 2147483000;
        width: 54px;
        height: 54px;
        border-radius: 999px;
        border: 1px solid rgba(18, 16, 14, 0.18);
        background: #fbf8f2;
        color: #12100e;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 18px 45px rgba(18, 16, 14, 0.16);
        cursor: pointer;
        transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
      }
      .ciel-concierge-launcher:hover {
        transform: translateY(-2px);
        box-shadow: 0 22px 55px rgba(18, 16, 14, 0.2);
        background: #fffdf8;
      }
      .ciel-concierge-launcher svg {
        width: 24px;
        height: 24px;
      }
      .ciel-concierge-label {
        position: fixed;
        right: max(86px, calc(env(safe-area-inset-right) + 86px));
        bottom: max(32px, calc(env(safe-area-inset-bottom) + 32px));
        z-index: 2147482999;
        padding: 9px 12px;
        border: 1px solid rgba(18, 16, 14, 0.12);
        background: rgba(251, 248, 242, 0.94);
        color: #12100e;
        font: 600 11px/1.1 Arial, Helvetica, sans-serif;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        box-shadow: 0 14px 34px rgba(18, 16, 14, 0.11);
        pointer-events: none;
      }
      .ciel-concierge-backdrop {
        position: fixed;
        inset: 0;
        z-index: 2147483001;
        background: rgba(18, 16, 14, 0.24);
        opacity: 0;
        pointer-events: none;
        transition: opacity 160ms ease;
      }
      .ciel-concierge-panel {
        position: fixed;
        right: max(22px, env(safe-area-inset-right));
        bottom: max(92px, calc(env(safe-area-inset-bottom) + 92px));
        z-index: 2147483002;
        width: min(390px, calc(100vw - 36px));
        height: auto;
        max-height: min(720px, calc(100dvh - 126px));
        overflow: hidden;
        background: #fbf8f2;
        color: #12100e;
        border: 1px solid rgba(18, 16, 14, 0.16);
        box-shadow: 0 26px 70px rgba(18, 16, 14, 0.22);
        transform: translateY(16px) scale(0.98);
        opacity: 0;
        pointer-events: none;
        transition: transform 180ms ease, opacity 180ms ease;
      }
      .ciel-concierge-open .ciel-concierge-backdrop {
        opacity: 1;
        pointer-events: auto;
      }
      .ciel-concierge-open .ciel-concierge-panel {
        transform: translateY(0) scale(1);
        opacity: 1;
        pointer-events: auto;
        display: flex;
        flex-direction: column;
      }
      .ciel-concierge-head {
        flex: 0 0 auto;
        display: grid;
        grid-template-columns: 1fr 42px;
        gap: 16px;
        align-items: start;
        padding: 22px 22px 14px;
        border-bottom: 1px solid rgba(18, 16, 14, 0.1);
      }
      .ciel-concierge-kicker {
        margin: 0 0 9px;
        font: 700 11px/1.1 Arial, Helvetica, sans-serif;
        letter-spacing: 0.18em;
        text-transform: uppercase;
      }
      .ciel-concierge-title {
        margin: 0;
        font-family: Georgia, 'Times New Roman', serif;
        font-size: clamp(27px, 7vw, 38px);
        line-height: 0.96;
        letter-spacing: 0;
        font-weight: 400;
      }
      .ciel-concierge-close {
        width: 38px;
        height: 38px;
        border: 1px solid #12100e;
        border-radius: 0;
        background: #12100e;
        color: #fbf8f2;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 20px;
        line-height: 1;
      }
      .ciel-concierge-body {
        flex: 1 1 auto;
        min-height: 0;
        padding: 16px 18px 18px;
      }
      .ciel-concierge-body .smartline-agent-widget,
      .ciel-concierge-body .agent-window {
        max-width: none;
        width: 100%;
      }
      .ciel-concierge-body .agent-window {
        background: transparent !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }
      .ciel-concierge-body .smartline-agent-widget,
      .ciel-concierge-body .agent-window,
      .ciel-concierge-body .agent-window-body {
        min-height: 0 !important;
      }
      .ciel-concierge-body .agent-window-header,
      .ciel-concierge-body .agent-waveform {
        display: none !important;
      }
      .ciel-concierge-body .agent-window-body,
      .ciel-concierge-body .smartline-native .agent-window-body {
        display: flex !important;
        flex-direction: column !important;
        min-height: 0 !important;
        max-height: calc(min(720px, 100dvh - 126px) - 180px) !important;
        background: transparent !important;
        padding: 0 !important;
      }
      .ciel-concierge-body .agent-messages {
        flex: 1 1 auto !important;
        min-height: 130px !important;
        max-height: clamp(160px, 34dvh, 270px) !important;
        overflow-y: auto !important;
        overscroll-behavior: contain;
        display: flex !important;
        flex-direction: column !important;
        gap: 8px !important;
        padding: 0 2px 10px 0 !important;
        margin: 0 0 10px !important;
        scrollbar-width: thin;
      }
      .ciel-concierge-body .agent-msg {
        border-radius: 0;
        box-sizing: border-box;
        max-width: 94% !important;
        padding: 9px 11px !important;
        font: 400 14px/1.45 Arial, Helvetica, sans-serif !important;
        overflow-wrap: anywhere;
        word-break: normal;
      }
      .ciel-concierge-body .agent-msg p,
      .ciel-concierge-body .agent-mic-notice p,
      .ciel-concierge-body .agent-status {
        margin: 0 !important;
        font: inherit !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
      }
      .ciel-concierge-body .agent-msg-user {
        align-self: flex-end !important;
        background: #12100e !important;
        color: #fbf8f2 !important;
        box-shadow: none !important;
      }
      .ciel-concierge-body .agent-msg-assistant,
      .ciel-concierge-body .smartline-native .agent-msg-assistant {
        align-self: flex-start !important;
        background: #fffdf8 !important;
        color: #12100e !important;
        border: 1px solid rgba(18, 16, 14, 0.12) !important;
      }
      .ciel-concierge-body .agent-controls,
      .ciel-concierge-body .smartline-native .agent-controls {
        flex: 0 0 auto !important;
        margin: 0 !important;
        padding: 0 !important;
        background: transparent !important;
        border-radius: 0 !important;
      }
      .ciel-concierge-body .btn-icon,
      .ciel-concierge-body svg.btn-icon,
      .ciel-concierge-body .agent-input-row .btn-send .btn-icon,
      .ciel-concierge-body .agent-voice-row .btn-voice .btn-icon,
      .ciel-concierge-body .agent-voice-row .btn-stop .btn-icon {
        width: 16px !important;
        height: 16px !important;
        max-width: 16px !important;
        max-height: 16px !important;
        flex: 0 0 16px !important;
        display: block !important;
      }
      .ciel-concierge-body .agent-input-row {
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) 48px !important;
        gap: 8px !important;
      }
      .ciel-concierge-body .agent-input-row input,
      .ciel-concierge-body .smartline-native .agent-input-row input {
        border: 1px solid rgba(18, 16, 14, 0.22) !important;
        border-radius: 0 !important;
        background: #fffdf8 !important;
        color: #12100e !important;
        font: 400 16px/1.2 Arial, Helvetica, sans-serif;
        min-height: 46px !important;
        height: 46px !important;
        padding: 0 12px !important;
      }
      .ciel-concierge-body .agent-input-row .btn-send,
      .ciel-concierge-body .agent-voice-row .btn-voice,
      .ciel-concierge-body .agent-voice-row .btn-stop {
        border-radius: 0 !important;
        box-shadow: none !important;
        background: #12100e !important;
        color: #fbf8f2 !important;
        border: 1px solid #12100e !important;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        font: 700 11px/1 Arial, Helvetica, sans-serif;
        min-height: 46px !important;
        padding: 0 12px !important;
      }
      .ciel-concierge-body .agent-input-row .btn-send .btn-label {
        display: none !important;
      }
      .ciel-concierge-body .agent-voice-row {
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        gap: 8px !important;
      }
      .ciel-concierge-body .agent-voice-row .btn-voice,
      .ciel-concierge-body .smartline-native .agent-voice-row .btn-voice {
        background: transparent !important;
        color: #12100e !important;
      }
      .ciel-concierge-body .agent-voice-row .sl-voice-off {
        display: none !important;
      }
      .ciel-concierge-body .agent-status {
        flex: 0 0 auto !important;
        min-height: 18px;
        margin: 10px 0 0;
        color: rgba(18, 16, 14, 0.58) !important;
        font: 400 12px/1.4 Arial, Helvetica, sans-serif;
        text-align: left;
      }
      .ciel-concierge-body .agent-mic-notice,
      .ciel-concierge-body .smartline-native .agent-mic-notice {
        flex: 0 0 auto !important;
        display: none;
        margin: 0 0 10px !important;
        padding: 9px 10px !important;
        background: #fffdf8 !important;
        color: rgba(18, 16, 14, 0.68) !important;
        border-radius: 0 !important;
        border: 1px solid rgba(18, 16, 14, 0.12);
        font: 400 12px/1.35 Arial, Helvetica, sans-serif !important;
      }
      @media (max-width: 640px) {
        .ciel-concierge-label { display: none; }
        .ciel-concierge-panel {
          right: 12px;
          left: 12px;
          bottom: max(86px, calc(env(safe-area-inset-bottom) + 86px));
          width: auto;
          max-height: calc(100dvh - 116px);
        }
        .ciel-concierge-head { padding: 20px 18px 12px; }
        .ciel-concierge-body { padding: 16px; }
        .ciel-concierge-title { font-size: clamp(28px, 9vw, 34px); }
        .ciel-concierge-body .agent-window-body,
        .ciel-concierge-body .smartline-native .agent-window-body {
          max-height: calc(100dvh - 270px) !important;
        }
        .ciel-concierge-body .agent-messages {
          min-height: 120px !important;
          max-height: calc(100dvh - 430px) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const found = Array.from(document.scripts).find((script) => script.src === src);
      if (found) return resolve();
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function buildWidget() {
    injectCss();

    const root = document.createElement('div');
    root.className = 'ciel-concierge-root';
    root.innerHTML = `
      <button class="ciel-concierge-launcher" type="button" aria-label="Open Ciel AI voice stylist">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
          <path d="M12 3a3 3 0 0 1 3 3v5a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3Z"/>
          <path d="M19 10v1a7 7 0 0 1-14 0v-1"/>
          <path d="M12 18v3"/>
          <path d="M8 21h8"/>
        </svg>
      </button>
      <div class="ciel-concierge-label">AI Voice</div>
      <div class="ciel-concierge-backdrop"></div>
      <aside class="ciel-concierge-panel" aria-hidden="true" aria-label="Ciel AI voice stylist">
        <div class="ciel-concierge-head">
          <div>
            <p class="ciel-concierge-kicker">Ciel AI Voice</p>
            <h2 class="ciel-concierge-title">Talk to the cashmere stylist.</h2>
          </div>
          <button class="ciel-concierge-close" type="button" aria-label="Close">×</button>
        </div>
        <div class="ciel-concierge-body">
          <div data-smartline-agent data-ciel-shop="${shop}" data-agent-name="Ciel Cashmere Concierge" data-agent-avatar="CC" data-api-base="${apiBase}"></div>
        </div>
      </aside>
    `;
    document.body.appendChild(root);

    const launcher = root.querySelector('.ciel-concierge-launcher');
    const close = root.querySelector('.ciel-concierge-close');
    const backdrop = root.querySelector('.ciel-concierge-backdrop');
    const panel = root.querySelector('.ciel-concierge-panel');
    const open = () => {
      document.documentElement.classList.add('ciel-concierge-open');
      panel.setAttribute('aria-hidden', 'false');
    };
    const hide = () => {
      document.documentElement.classList.remove('ciel-concierge-open');
      panel.setAttribute('aria-hidden', 'true');
    };
    launcher.addEventListener('click', open);
    close.addEventListener('click', hide);
    backdrop.addEventListener('click', hide);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hide();
    });

    loadScript(smartlineSrc).catch((error) => {
      console.error('Ciel concierge failed to load:', error);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildWidget);
  } else {
    buildWidget();
  }
})();
